import { cn } from '../lib/cn.js';

const VARIANT_TAG = {
  h1: 'h1', h2: 'h2', h3: 'h3', h4: 'h4',
  lede: 'p', body: 'p', small: 'p',
  eyebrow: 'span', mono: 'span',
};

const VARIANT_CLASSES = {
  h1: 'font-display font-semibold text-[clamp(40px,6vw,72px)] leading-[0.98] tracking-[-0.02em] text-ink',
  h2: 'font-display font-semibold text-[clamp(28px,4vw,44px)] leading-[1.05] tracking-[-0.02em] text-ink',
  h3: 'font-display font-semibold text-[clamp(20px,2.2vw,26px)] leading-[1.2] tracking-[-0.02em] text-ink',
  h4: 'font-display font-semibold text-lg leading-snug tracking-tight text-ink',
  lede: 'text-[19px] leading-[1.55] text-muted',
  body: 'text-[17px] leading-[1.55] text-ink',
  small: 'text-sm leading-[1.5] text-ink',
  eyebrow: 'text-xs font-semibold uppercase tracking-[0.08em] text-muted',
  mono: 'font-mono text-[13px] text-ink',
};

export function Text({ variant = 'body', as, className, children, ...rest }) {
  const Tag = as || VARIANT_TAG[variant];
  return (
    <Tag className={cn(VARIANT_CLASSES[variant], className)} {...rest}>
      {children}
    </Tag>
  );
}
